export enum InterpretationType {
    Horizon = 1,
    Fault = 2
}